import { render } from "./Navbar.vue?vue&type=template&id=7fedc39e&bindings={\"isOpen\":\"setup\"}"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script